export const FEATURE_SEGMENT_ENABLED = !!Number(process.env.REACT_APP_FEATURE_SEGMENT_ENABLED);
export const FEATURE_SIGNUP_V2_ENABLED = !!Number(process.env.REACT_APP_FEATURE_SIGNUP_V2_ENABLED);
export const FEATURE_DEV_SELECTOR_ENABLED = !!Number(process.env.REACT_APP_DEV_SELECTOR_ENABLED);
export const FEATURE_ROLLBAR_ENABLED = !!Number(process.env.REACT_APP_FEATURE_ROLLBAR_ENABLED);
export const FEATURE_ONBOARDING_QUIZ_ENABLED = !!Number(
  process.env.REACT_APP_FEATURE_ONBOARDING_QUIZ_ENABLED,
);
